import styled from 'styled-components';

import { FormContextValues, NumberPatternType, Translate } from '@dreryk/react-common';
import { NumberInput, StyledMaxWidth } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

const StyledFieldContainer = styled.div`
   position: relative;
`;

const StyledUnitContainer = styled.div`
   position: absolute;
   top: 37px;
   left: 83px;
`;

const APPOINTMENTS_COUNT_MIN = 2;
const APPOINTMENTS_COUNT_MAX = 99;
const TOTAL_NUMBER_OF_APPOINTMENTS_FIELD_NAME = 'totalNumberOfAppointments';

type AppointmentsCountInputFormBeanPart = { [TOTAL_NUMBER_OF_APPOINTMENTS_FIELD_NAME]?: number };
type AppointmentsCountInputFieldProps = Pick<FormContextValues<AppointmentsCountInputFormBeanPart>, 'register'>;

export const AppointmentsCountInputField = (props: AppointmentsCountInputFieldProps): JSX.Element => {
   return (
      <StyledFieldContainer>
         <StyledMaxWidth maxWidth={75}>
            <NumberInput
               testId={TOTAL_NUMBER_OF_APPOINTMENTS_FIELD_NAME}
               label={appointmentsTranslationKeys.create.form.totalNumberOfAppointments.label}
               controller={props.register(TOTAL_NUMBER_OF_APPOINTMENTS_FIELD_NAME, { required: true })}
               min={APPOINTMENTS_COUNT_MIN}
               max={APPOINTMENTS_COUNT_MAX}
               defaultValue={APPOINTMENTS_COUNT_MIN}
               pattern={NumberPatternType.POSITIVE_INTEGER}
               labelNoWrap
            />
         </StyledMaxWidth>
         <StyledUnitContainer>
            <Translate>{appointmentsTranslationKeys.create.form.totalNumberOfAppointments.unit}</Translate>
         </StyledUnitContainer>
      </StyledFieldContainer>
   );
};
